import React, { Component, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import Home from "./MyComponents/pages/Home";
import Foundation from "./MyComponents/pages/Foundation";
import TechGenics from "./MyComponents/pages/TechGenics";
import FAQ from "./MyComponents/pages/FAQ";
import Testimonial from "./MyComponents/pages/Testimonial";
import StreamLearning from "./MyComponents/pages/StreamLearning";
import Contact from "./MyComponents/pages/Contact";
import KeyStatistics from "./MyComponents/pages/KeyStatistics";
import Assessment from "./MyComponents/pages/Assessment";
import Footer from "./MyComponents/Footer";
import FoundationTechPrimers from "./MyComponents/pages/FoundationTechPrimers";
import FoundationFuncPrimers from "./MyComponents/pages/FoundationFuncPrimers";
// import SSOLogin from './SSOLogin';
// import {msalApp} from './utils/MSUtils';
import Gamification from "./MyComponents/pages/Gamification";
import FoundationComponent from "./MyComponents/pages/FoundationComponent";
import SearchNav from "./MyComponents/Searchnav";
import FoundationContact from "./MyComponents/FoundationContact";
import TechexpresswayFaq from "./MyComponents/pages/TechexpresswayFaq";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./MyComponents/PageLayout";
import Feedback from "./MyComponents/Feedback";
import FeedbackContent from "./MyComponents/FeedbackContent";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import AnalyticsVideo from "./MyComponents/AnalyticsVideo";
import Navbar from "./MyComponents/Navbar";
import AllAnalytics from "./MyComponents/AllAnalytics";
function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    console.log("0");
    if (activeAccount) {
      console.log("1");
      fetchAccessToken();
      console.log("2");
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      console.log(bearer);
      localStorage.setItem("token", bearer);
      console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  console.log(process.env.NODE_ENV,"environment",window.location.hostname,"location");
  return (
    <>
      <Router>
        <SearchNav />
        <Switch>
          <Route exact path="/home">
            <Home />
          </Route>
          <Route exact path="/foundation-component">
            <FoundationComponent />
          </Route>
          <Route exact path="/foundation-tech-primers">
            <FoundationTechPrimers />
          </Route>
          <Route exact path="/foundation-func-primers">
            <FoundationFuncPrimers />
          </Route>
          <Route exact path="/job-readiness">
            <TechGenics />
          </Route>
          {/* <Route exact path='/gamification'>
            <Gamification />
            </Route> */}
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/Testimonials">
            <Testimonial />
          </Route>
          <Route exact path="/analytics">
            <AllAnalytics />
          </Route>
          <Route exact path="/skill-learning-journey">
            <StreamLearning />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
          <Route exact path="/foundation-contact">
            <FoundationContact />
          </Route>
          <Route exact path="/key-statistics">
            <KeyStatistics />
          </Route>
          <Route exact path="/assessment-planner">
            <Assessment />
          </Route>
          <Route exact path="/techexpressway-faq">
            <TechexpresswayFaq />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/comment">
            <FeedbackContent />
          </Route>
        </Switch>
      </Router>
      <Feedback />
      <Footer />
    </>
  );
}
export default App;
